import { Web3Provider } from "@ethersproject/providers";
import { ethers } from "ethers";

export default function getLibrary(provider) {
	const library = new ethers.providers.Web3Provider(provider);
	library.pollingInterval = 8000; // frequency provider is polling
	return library;
}